import addressTypes from '@/constants/address-type';
import useDid from '@/hooks/use-did';
import api from '@/services/api/etr.js';
import { immerable } from 'immer';
import { orderBy, uniqBy } from 'lodash';
import { useState } from 'react';

class Etr {

	[immerable] = true

	constructor(params) {
		this.id = params.id
		this.name = params.name
		this.walletAddress = params.walletAddress
		this.email = params.email
		this.isPinned = params.isPinned
		this.type = params.type
	}
}

const useEtr = ({dataElementId, configData={}}) => {
	const [etrData, setEtrData] = useState([])
	const [etrLoading, setEtrLoading] = useState(false)
	const [etrErrorMsg, setEtrErrorMsg] = useState()
	const { toFindDid } = useDid()

	async function fetchEtr() {

		setEtrLoading(true)

		const [error, response] = await api.getSavedAddress()

		setEtrLoading(false)

		if (error) {
			return setEtrErrorMsg(error)
		}

		const etrData = combineAddress({data: response})

		const serializedData = etrData.map(entry => serialize(entry))
		const newItems = serializedData.map(dataParams => new Etr(dataParams))
		setEtrData(newItems)
	}

	function combineAddress({data}){
		const provideItems = configData?.provideItems
		const identity = configData?.identity
		
		const provideParticipants = provideItems?.find(item => item.id === dataElementId)?.to.filter(participant=> participant.id !== identity?.organization.id) || []

		const participants = uniqBy([...provideParticipants], 'id')

		let saveAddresses =[], pitstopAddresses=[], pinned =[]

		if(data?.savedAddresses && data?.savedAddresses?.length > 0){
			saveAddresses = data?.savedAddresses?.map(address => {
				return {
					id: address.savedAddressId,
					name: address.orgName,
					walletAddress: address.walletAddress,
					email: address.email,
					isPinned: address.isPinned,
					type: addressTypes.saved
				}
			})
		}

		if(data?.pitstopAddresses && data?.pitstopAddresses?.length > 0){
			pinned = data?.pitstopAddresses
		}

		if(participants && participants.length > 0){
			pitstopAddresses = participants?.map(participant => {
				return {
					id: participant.id,
					name: participant.name,
					walletAddress: toFindDid(participant.id),
					email: "",
					isPinned: pinned.includes(participant.id),
					type: addressTypes.pitstop
				}
			})
		}

		const allAddresses = orderBy([...saveAddresses,...pitstopAddresses], [(option) => option?.name?.toLowerCase(), ['asc']])
		return allAddresses
	}

	function serialize(entry) {
		return {
			id: entry.id,
			name: entry.name,
			walletAddress: entry.walletAddress,
			email: entry.email,
			isPinned: entry.isPinned,
			type: entry.type
		}
	}

	return {
		etrErrorMsg,
		fetchEtr,
		etrData,
		etrLoading,
		toFindDid
	}

}

export default useEtr
